<template></template>

<script>
  import 'jquery-validation'
  import 'jquery-validation/dist/additional-methods.js'
  
  export default {
    name: 'RegisterProfessionalExperience',
    mounted() {
      /**
       * Init Select2 for countries
       */
      const countries = $('.search-country')
      
      countries.select2({
        language: {
          noResults: function() {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })
      
      /**
       * Init JQuery validation
       */
      $(() => {
        $(document).ready(function() {
          $('.form').validate({
            ignore: [],
            highlight: function(element, errorClass, validClass) {
              $(element).addClass('is-invalid')
            },
            unhighlight: function(element, errorClass, validClass) {
              $(element).removeClass('is-invalid')
            },
            errorPlacement: function(label, element) {
              if(element.hasClass('select2-input')) {
                label.insertAfter(element.siblings('span.select2'))
              }
              else {
                label.insertAfter(element)
              }
              
              label.addClass('invalid-feedback')
            },
            rules: {
              institution: {
                required: true,
              },
              initials: {
                required: true,
              },
              country_id: {
                required: true,
              },
              start_of_period: {
                required: true,
              },
              end_of_period: {
                required: true,
              },
              main_activity: {
                required: true,
              },
              maint_activity_details: {
                required: function() {
                  return $('[name="main_activity"]').val() === 'Otra'
                },
              },
              position_held: {
                required: true,
              },
              maintains_a_bond: {
                required: true,
              },
              maintains_a_bond_details: {
                required: function() {
                  return $('[name="maintains_a_bond"]').val() === '1'
                },
              },
            },
            messages: {
              institution: {
                required: 'Este campo es requerido.',
              },
              initials: {
                required: 'Este campo es requerido.',
              },
              country_id: {
                required: 'Este campo es requerido.',
              },
              start_of_period: {
                required: 'Este campo es requerido.',
              },
              end_of_period: {
                required: 'Este campo es requerido.',
              },
              main_activity: {
                required: 'Este campo es requerido.',
              },
              maint_activity_details: {
                required: 'Este campo es requerido.',
              },
              position_held: {
                required: 'Este campo es requerido.',
              },
              maintains_a_bond: {
                required: 'Este campo es requerido.',
              },
              maintains_a_bond_details: {
                required: 'Este campo es requerido.',
              },
            },
            submitHandler(form) {
              form.submit()
            },
          })
        })

        /**
         * Show and hide options select
         */
        $('select[name="main_activity"]').on('change', function() {
            if (this.value === 'Otra') {
                $('#main-activity-details').removeClass('d-none');
            } else {
                $('#main-activity-details').addClass('d-none');
            }
        })
        
        $('select[name="maintains_a_bond"]').on('change', function() {
            if (this.value === '1') {
                $('#maintains-a-bond_details').removeClass('d-none');
            } else {
                $('#maintains-a-bond_details').addClass('d-none');
            }
        })
        
      })
    },
  }
</script>
